/*       */

import { gql } from '@apollo/client';

/**
 * Unified file for all workspace lazy-loading resource queries with pagination
 * These queries support startIndex/stopIndex for efficient lazy loading
 */

/**
 * Query to load workspace class resources with pagination
 * Uses aliases to return standardized 'data' and 'count' fields
 */
export const loadWorkspaceClassResourcesLazyQuery = gql`
    query loadWorkspaceClassResourcesQuery($id: ID!, $startIndex: Int, $stopIndex: Int) {
        workspace(id: $id) {
            id
            count: classResourcesCount
            data: classResources(startIndex: $startIndex, stopIndex: $stopIndex) {
                role
                class {
                    id
                    name
                    uri
                }
            }
        }
    }
`;

/**
 * Query to load workspace permissions (both permission and system_setting types) with pagination
 * Uses aliases to return standardized 'data' and 'count' fields
 */
export const loadWorkspacePermissionsLazyQuery = gql`
    query loadWorkspacePermissionsQuery($id: ID!, $startIndex: Int, $stopIndex: Int) {
        workspace: workspaceEntityResources(
            startIndex: $startIndex
            stopIndex: $stopIndex
            filterBy: [
                { field: "workspace.id", op: "=", value: $id }
                {
                    or: [
                        { field: "entity.type", op: "=", value: "permission" }
                        { field: "entity.type", op: "=", value: "system_setting" }
                    ]
                }
            ]
        ) {
            entity {
                id
                name
                type
            }
        }
    }
`;

/**
 * Generic query to load workspace entity resources with custom filterBy
 * Supports task, process, script, and other entity types
 * Uses filterBy variable to specify entity type and workspace ID
 */
export const loadWorkspaceEntityResourcesByTypeLazyQuery = gql`
    query loadWorkspaceEntityResourcesByTypeQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON]) {
        data: workspaceEntityResources(
            startIndex: $startIndex
            stopIndex: $stopIndex
            filterBy: $filterBy
        ) {
            entity {
                id
                name
                type
            }
        }
        count: workspaceEntityResources(
            filterBy: $filterBy
        ) {
            entity {
                id
            }
        }
    }
`;